<template>
    <swiper
            :modules="swiperModules"
            :slides-per-view="2"
            :space-between="16"
            :breakpoints="{
                500: {
                    spaceBetween: 33
                }
            }"
            :pagination="{
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 5
            }"
            :grid="{
                rows: 2,
                fill: 'row'
            }"
            navigation
            class="skin__articles"
        >
            <swiper-slide v-for="article in props.showSkinArticles" :key="article.id" class="skin__content">
                <a
                    :href="article.link"
                    target="_blank"
                    @click="gtagEvent(article.link, '身體乳介紹', article.title,  props.skinType)"
                >
                    <div class="skin__articles__img">
                        <img :src="article.image" class="rwdimg" loading="lazy" :alt="article.title" />
                    </div>
                    <h3>{{ article.title }}</h3>
                </a>
            </swiper-slide>
        </swiper>
</template>

<script setup>
import { defineProps } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Grid } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';

import gtagEvent from '@/assets/js/gtag';

const swiperModules = [Navigation, Pagination, Grid];
const props = defineProps({
    showSkinArticles: Array,
    skinType: String
});

</script>

<style lang="scss" scoped>
@import '@/styles/theSkinSwiper';
@import '@/styles/swiperOption';
</style>